import React, { FormEvent, useContext, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { Button, TextField, makeStyles, useQuery } from '@cicero/ui'
import { StoreContext } from '../models/services'
import { UserSchema, useModel } from '../models'

export const LoginForm = () => {
  const { formWrapper } = styles()
  const history = useHistory()
  const query = useQuery()
  const store = useContext(StoreContext)
  const User = useModel(UserSchema)

  const [username, setUsername] = useState('a@lexholden.com')
  const [password, setPassword] = useState('password')

  const tryToLogin = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const { response } = await store.API.POST('/login', { body: { username, password } })
    const { user } = response
    const currentUser = await User.PERSIST(user)
    UserSchema.setSession(store, currentUser)
    const redirect = query.get('redirect')
    history.push(redirect || '/')
  }

  return (
    <form className={formWrapper} onSubmit={tryToLogin}>
      <TextField id="username" label="Username" required autoFocus={true} value={username} onChange={e => setUsername(e.target.value)} />
      <br />
      <TextField id="password" label="Password" type="password" required value={password} onChange={e => setPassword(e.target.value)} />
      <br />
      <Button color="primary" type="submit">Login</Button>
    </form>
  )
}

const styles = makeStyles({
  formWrapper: {
    padding: 16,
    margin: 16,
  },
})
